import { combineReducers } from 'redux'
import tabs from './tabs'
import buttons from './buttons'
import collapsed from './collapsed'
import theme from './theme'
import roles from './roles'
import redirectUrl from './redirectUrl'
import blackSystems from './blackSystems'
const rootReducer = combineReducers({
    tabs,
    buttons,
    collapsed,
    theme,
    roles,
    redirectUrl,
    blackSystems,
})
export default rootReducer